import { SetupPayload } from '../../types/androidMessages';

// Payload data gets sent as a GET param called "d" with the following format:
// base_64_encode ( json_encode ( {d: "device uid", t: "authorization_token"} ) )
export const extractPayload = (url: string): SetupPayload => {
  const urlParams = new URLSearchParams(new URL(url).search);

  const b64EncodedData = urlParams.get('d');
  if (!b64EncodedData) {
    throw new Error('Unexpected payload!');
  }

  let data;
  try {
    data = JSON.parse(atob(b64EncodedData));
  } catch (error) {
    throw new Error('Unexpected payload!');
  }

  if (!data || !data.t || !data.d) {
    throw new Error('Unexpected payload!');
  }

  return {
    token: data.t,
    deviceUid: data.d,
  };
};
